module.exports = __webpack_public_path__ + "static/img/8.ca04c68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/8.png
// module id = Iyc4
// module chunks = 0